import { render, staticRenderFns } from "./stageInit.vue?vue&type=template&id=af88d3e6&"
import script from "./stageInit.vue?vue&type=script&lang=js&"
export * from "./stageInit.vue?vue&type=script&lang=js&"
import style0 from "./stageInit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports